export default __webpack_public_path__ + "static/iphone-286974589bc247e687972d608e823669.png";